import { SiteFiltersStore } from "../store";
import { useSnapshot } from "valtio";

export const useSearchString = (store: SiteFiltersStore) => {
  const { searchString } = useSnapshot(store);

  return searchString;
};
